import * as Sentry from '@sentry/nextjs'

export const captureException = (err) => {
  Sentry.captureException(err)
}
